import { render, staticRenderFns } from "./AccountJson.vue?vue&type=template&id=bc487664"
import script from "./AccountJson.vue?vue&type=script&lang=js"
export * from "./AccountJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports